import {Injectable} from '@angular/core';
import {NeqHttpClient as HttpClient} from '@sharedrest/http-client.config';
import {
  RestResponse
} from '@sharedrest/data.restservice';
import {DomainRightFilterDto} from '@sharedrest/equation.restservice';
import { environment } from '@sharedenvironment';

@Injectable()
export class CustomEquationServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  exportDomainMatrixRight(arg0: DomainRightFilterDto): RestResponse<any> {
    return this.httpClient.request({
      method: 'DOWNLOAD',
      url: uriEncoding`rights/matrices`,
      data: arg0,
      responseType: 'blob',
      downloadMediaType: 'application/octet-stream'
    });
  }
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = environment.equation.baseUrl;
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}
